import { Component, OnInit } from '@angular/core';
import {AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

declare var Isotope: any;

@Component({
    standalone: false,
    selector: 'core-block-toggle',
    templateUrl: './block-toggle.component.html',
})

export class BlockToggleComponent extends BlockAbstractComponent implements OnInit {
    toggle: boolean = false;
    tope: any;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        private location: Location,
        private router: Router,
    ) {
        super(
            parser,
            auth,
        );
    }

    setActive(target: string) {
        if (this.router.url === '/' || this.router.url === '/default') {
            return this.toggle = !this.toggle;
        } else return this.router.url === target;
    }

    setState(event: any) {
        const target = event.target.hash;
        this.router.navigateByUrl(target, {
            skipLocationChange: true
        });

        this.location.replaceState(target);

        setTimeout (() => {
            this.initIsotopes();
        }, 100);
    }

    initIsotopes() {
        const grid = document.querySelector('.grid');
        this.tope = new Isotope(grid, {
                // layoutMode: 'fitRows'
            }
        );
    }
}
